import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "label", "panel"]
  static values = {
    closeLabel: String,
    openLabel: String
  }

  connect() {
    this.close()
  }

  toggle(event) {
    if (this.buttonTarget.getAttribute("aria-expanded") === "true") {
      this.close()
    } else {
      this.open()
    }

    if (event.detail > 0) this.buttonTarget.blur()
  }

  open() {
    this.panelTarget.hidden = false
    this.buttonTarget.setAttribute("aria-expanded", "true")
    this.labelTarget.textContent = this.closeLabelValue
  }

  close(event) {
    this.panelTarget.hidden = true
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.labelTarget.textContent = this.openLabelValue

    if (event?.type === "keydown") this.buttonTarget.focus()
  }

  closeOnDesktop() {
    if (window.matchMedia("(min-width: 768px)").matches) this.close()
  }
}
